import "./Plumnote.css";
import { Link } from "react-router-dom";
import Footer from "../footer/Footer";
import icon from "../../assets/images/plumnote/icon.png";

function Plumnote({
  data: {
    name,
    tagline,
    description,
    storeUrl,
    features,
    btnBack,
    btnInstall,
  },
}) {
  return (
    <>
      <main className="pn-container">
        <div className="pn-back">
          <h3>
            <Link to="..">{btnBack}</Link>
          </h3>
        </div>
        <section className="pn-title">
          <img className="pn-icon" src={icon} alt={name} width={96} height={96} />
          <h2>{name}</h2>
          <h4 className="pn-tagline">{tagline}</h4>
          <p className="pn-description">{description}</p>
          <a
            className="pn-install"
            href={storeUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {btnInstall}
          </a>
        </section>
        <section className="pn-features">
          <h2>Features</h2>
          <ul>
            {features.map((elem, index) => (
              <li key={index}>{elem}</li>
            ))}
          </ul>
        </section>
        <Footer
          termsLink="/plumnote/terms-of-service"
          privacyLink="/plumnote/privacy-policy"
        />
      </main>
    </>
  );
}

export default Plumnote;
